import logo from "@/assets/logo.webp";

interface BrandedLoaderProps {
  message?: string;
}

export function BrandedLoader({ message = "Loading your crew portal…" }: BrandedLoaderProps) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0B1422] text-[#E8DCC8] px-6">
      <img
        src={logo}
        alt="Thumb Premier Painting"
        className="h-32 w-auto object-contain animate-pulse mb-6"
      />
      <div className="flex items-center gap-3">
        <span className="h-2 w-2 rounded-full bg-[#D4A82A] animate-pulse" />
        <span className="h-2 w-2 rounded-full bg-[#D4A82A] animate-pulse [animation-delay:150ms]" />
        <span className="h-2 w-2 rounded-full bg-[#D4A82A] animate-pulse [animation-delay:300ms]" />
      </div>
      <p className="mt-5 text-sm tracking-wide text-[#94A3B8]">{message}</p>
    </div>
  );
}

export default BrandedLoader;